// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"qcbEz97l","ButtonSkeleton":"nhmf3K7f","IconPlaceholder":"o0rciMBo","Textbox":"nhP7RI7g","TextboxPlaceholder":"h38QZk9c"};